import React from "react";
import styles from "../styles.module.css";
import Delete from "../../../icons/delete";
import { useState, useEffect } from "react";

export default function Header({ header, deleteHeader, updateHeader, index }) {
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    setKey(header.key);
    setValue(header.value);
  }, []);

  const handleUpdate = (e) => {
    const newheader = { key, value, id: header.id };
    updateHeader(newheader, index);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    deleteHeader(index);
  };
  return (
    <div className={styles.header}>
      <div style={{ marginRight: 8 }}>
        <div className={styles.headerTitle}>Key</div>
        <input
          onBlur={handleUpdate}
          value={key}
          onChange={(e) => setKey(e.target.value)}
          className={styles.headerInput}
        />
      </div>
      <div style={{ flexGrow: 2 }}>
        <div className={styles.headerTitle}>Value</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            onBlur={handleUpdate}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={styles.headerInput}
          />
          <Delete onClick={handleDelete} className={styles.deleteIcon} />
        </div>
      </div>
    </div>
  );
}
